export const TOKEN_VARIANTS_MAP = {
  DEFAULT: "default",
  ADDITIONAL: "additional"
}

export const tokenNameConfig = {
  [TOKEN_VARIANTS_MAP.DEFAULT]: {
      token: "token",
      refresh_token: "refresh_token",
  },
  [TOKEN_VARIANTS_MAP.ADDITIONAL]: {
      token: "additional-form-token",
      refresh_token: "additional-form-refresh-token",
  }
}

export const getTokenNames = (module) => tokenNameConfig[module] || tokenNameConfig.default;

const tokenStorage = {
  [TOKEN_VARIANTS_MAP.DEFAULT]: {
    cookies: true,
  },
  [TOKEN_VARIANTS_MAP.ADDITIONAL]: {
    cookies: false,
  }
}

export const additionalTokenNames = tokenNameConfig[TOKEN_VARIANTS_MAP.ADDITIONAL];

export const getTokenStorage = (module) => tokenStorage[module] || tokenStorage.default;
